import React from "react";
import { CardContent, CardContentProps } from "@material-ui/core";

export interface CardBodyProps extends CardContentProps {

}

export default function CardBody(props: CardBodyProps) {

  const { style, ...rest } = props;

  return (
    <CardContent {...rest} style={{ overflow: 'visible', ...style }} />
  );
}


